import { styled } from '@mui/material/styles';

const Divider = styled('div')(() => ({
	width: "100%",
	borderTop: "1px solid var(--theme-nonary)"
}));

export default Divider;